// extracted by mini-css-extract-plugin
module.exports = {"imageDisplay":"imageDisplay_1ApwLOtr"};